<template>
  <header 
    id="header" 
    v-if="$route.name !== 'loginPage'"
    :class="{ 'header--hidden': !isHeaderVisible }"
  >
    <div>
      <v-container
        class="pa-0"
        fluid
        :class="[$store.getters.isMobile ? 'pr-5 pl-5' : 'pr-10 pl-10']"
      >
        <div class="header-layout">
          <!-- Right Side -->
          <div class="header-section">
            <div
              class="navlink-container"
              v-if="$store.getters.isDesktop"
            >
              <ToCategoryBtn />
              <div class="links" v-if="$route.name == 'Products' || $route.name == 'CategoryProducts'">
                <NavLink
                  v-for="link in catalogLinks"
                  :title="link.title"
                  :key="link.id"
                  :navigationName="link.path"
                  :isActive="$route.path === '/products'"
                  :icon="link.icon"
                  @onNavLinkClick="navClickHandler(link.path)"
                />
                <NavLink
                  v-for="link in $store.getters['Category/getRootCategories']"
                  :title="link.title"
                  :key="link.id"
                  :navigationName="link.path"
                  :icon="link.icon"
                  :isActive="$route.params.rootCategory === link.path"
                  @onNavLinkClick="rootCategoryClickHandler(link.path)"
                />
                <NavLink
                  v-if="isAuth"
                  :title="'מועדפים'"
                  :navigationName="'favorites'"
                  :icon="'mdi-star'"
                  :isActive="$route.path === '/favorites'"
                  @onNavLinkClick="rootCategoryClickHandler('favorites')"
                />
              </div>
            </div>
            <div v-else>
              <CloseSideMenuBtn :color="black" class="mr-1 mb-2" size="25" />
              <teleport to="#modal_backdrop">
                <v-navigation-drawer
                  class="menu-side-modal bg-grey-lighten-5"
                  v-model="isMenuSideOpen"
                  temporary
                  disable-route-watcher
                  touchless
                  @update:modelValue="handleDrawerClose"
                >
                  <SideMenu
                    :userName="userName"
                    :isShowPersonalArea="isShowPersonalArea"
                    :isAuth="isAuth"
                    :links="links"
                    @closeSideMenu="handleDrawerClose"
                  />
                </v-navigation-drawer>
              </teleport>
            </div>
          </div>

          <!-- Center Logo -->
          <div class="header-section logo-container">
            <img
              class="siteLogo"
              src="@/assets/images/logohe.png"
              alt="logo image"
              @click="gotoHomePage"
            />
          </div>

          <!-- Left Side -->
          <div class="header-section personal-area-section">
            <template v-for="link in generalLinks" :key="link.id">
              <NavLink
                :title="link.title"
                :navigationName="link.path"
                :icon="link.icon"
                @onNavLinkClick="navClickHandler(link.path)"
                v-if="$store.getters.isDesktop"
              />
            </template>
            <div v-if="isShowPersonalArea" class="personal-area-container">
              <personal-area-btn
                v-if="$store.getters.isDesktop"
                :userName="userName"
                :isAuth="isAuth"
              />
              <CartBtn
                v-if="isAuth"
                @click="openCartModel"
                :counter="getCartOrderLinesNumber"
              />
            </div>
          </div>
        </div>
        <div
          class="cart-wrapper"
          v-if="
            isOpenCart &&
            $route.name !== 'Products' &&
            $route.name !== 'CategoryProducts' &&
            $route.name !== 'checkOut'
          "
        >
          <Cart
            @closeCart="openCartModel"
            :isCartModelOpenHeader="isOpenCart"
            :isHeader="true"
          />
        </div>
      </v-container>
    </div>
    <v-progress-linear
      v-if="isLoading"
      color="#35bbe0a5"
      :height="3"
      indeterminate
    ></v-progress-linear>
  </header>
</template>

<script>
import { mapGetters } from "vuex";
import { useScrollDirection } from '@/composables/useScrollDirection'
import CartBtn from "../helpers/Header/CartBtn.vue";
import NavLink from "../helpers/Header/NavLink.vue";
// import BaseButton from "../UI/BaseButton.vue";
import PersonalAreaBtn from "../helpers/Header/PersonalAreaBtn.vue";
import SideMenu from "../helpers/Header/SideMenu.vue";
import CloseSideMenuBtn from "../helpers/Header/CloseSideMenuBtn.vue";
import ToCategoryBtn from "../helpers/Header/ToCategoryBtn.vue";
import Cart from "../menus/Cart.vue";

export default {
  components: {
    NavLink,
    CartBtn,
    Cart,
    PersonalAreaBtn,
    SideMenu,
    CloseSideMenuBtn,
    ToCategoryBtn,
  },
  data() {
    return {
      userOption: "",
      locale: this.$i18n.locale,
      cartT: this.cartTotal,
      isMenuSideOpen: false,
      catalogLinks: [
        {
          id: 1,
          title: "כל המוצרים",
          path: "/products",
        },
      ],
      generalLinks: [
        {
          id: 1,
          title: "קצת עלינו",
          path: "#about",
        },
        {
          id: 2,
          title: "יצירת קשר",
          path: "#contact",
        },
      ],
    };
  },
  setup() {
    const { isHeaderVisible } = useScrollDirection()
    return {
      isHeaderVisible
    }
  },
  methods: {
    
    async navClickHandler(path) {
      if (path.startsWith("#")) {
        if (this.$router.name !== "home") {
          await this.$router.push("/");
        }
        const element = document.getElementById(path.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      } else {
        this.$router.push(path);
      }
    },
    rootCategoryClickHandler(path) {
      this.$router.replace(`/${path}`, { replace: true });
    },
    openCartModel() {
      this.$store.dispatch("Orders/setCartModel", !this.isOpenCart);
    },
    handleDrawerClose() {
      this.$store.commit("toggleMenu");
    },
    gotoHomePage() {
      this.$store.commit("setIsShowDesktopHome", false);
      this.$router.push("/");
    },
    openMobileSideBar() {
      this.$store.commit("setIsOpenMobileSideBar", true);
    },
  },
  computed: {
    isShowPersonalArea() {
      if (this.isAuth) return true;
      if (!this.isAuth && this.$route.name !== "Products" && this.$route.name !== "CategoryProducts" && this.$route.name !== "home") return false;
      else return true;
    },
    links() {
      if (this.$route.name === "Products" || this.$route.name === "CategoryProducts") {
        return [...this.catalogLinks];
      } else {
        return [
          {
            id: 1,
            title: "קצת עלינו",
            path: "#about",
          },
          {
            id: 2,
            title: "יצירת קשר",
            path: "#contact",
          },
        ];
      }
    },
    logoUrl() {
      return "@/assets/images/logohe.png";
    },
    ...mapGetters({
      getCartOrderLinesNumber: "Orders/getCartOrderLinesNumber",
      isAuth: "AuthModule/isAuthenticated",
      user: "AuthModule/getUser",
      isUserRollFinance: "AuthModule/isUserRollFinance",
      userName: "AuthModule/getUserName",
      customerName: "AuthModule/getCustomerName",
      cartTotal: "Orders/getCartTotal",
      isOpenCart: "Orders/getIsCartModelOpen",
      getFinances: "Finances/getFinances",
      isLoading: "isLoading",
      getIsOpenMenu: "isOpenMenu",
      OpenReturnCustDocsAndInvoices:
        "Invoices/getOpenReturnCustDocsAndInvoices",
    }),
  },
  watch: {
    getIsOpenMenu(val) {
      this.isMenuSideOpen = val;
    },
    $route() {
      if (this.isMenuSideOpen) {
        this.handleDrawerClose();
      }
    },
    locale(val) {
      this.$i18n.locale = val;
      document.dir = this.$i18n.messages[this.$i18n.locale].direction;
      document.documentElement.lang = this.$i18n.locale;
      this.$vuetify.locale.current = this.$i18n.locale;
    },
  },
};
</script>

<style lang="scss">
.personal-area-container {
  .v-icon {
    color: $iconColor !important;
    font-size: 25px !important;
  }

  @media (max-width: 425px) {
    .v-icon {
      font-size: 20px !important;
    }
  }
}
</style>

<style scoped lang="scss">
header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: white;
  transition: transform 0.3s ease-in-out;
  width: 100%;
  z-index: 999;
}

.header--hidden {
  transform: translateY(-100%);
}

.cart-wrapper {
  position: fixed;
  background: white;
  // border-radius: 20px;
  top: 0px;
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.2666666667);
  padding: 20px;
  left: 20px;
  z-index: 10;
}

.header-layout {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
  gap: 20px;
}

.header-section {
  display: flex;
  align-items: center;
}

.logo-container {
  justify-content: center;
}

.personal-area-section {
  justify-content: flex-end;
}

.navlink-container {
  justify-content: flex-start;
  display: flex;
  align-items: center;
  gap: 10px;
}

.personal-area-container {
  display: flex;
  align-items: center;
  gap: 20px;
  .v-icon {
    color: black !important;
  }
}

.progress {
  position: absolute;
}

.col {
  padding: unset !important;
}

a {
  font-size: $smallTextSize;
  vertical-align: unset;
  color: $primaryTextColor !important;
}

header {
  box-shadow: 0px 2px 8px #00000010;
  z-index: 10 !important;
  background-color: white;
  // position: relative;
  .container {
    padding: 10px 0 5px 0px;
  }
}

.siteLogo:lang(en) {
  margin: unset;
}

.siteLogo {
  cursor: pointer;
  margin-bottom: 7px;
  margin-top: 7px;
}

@media only screen and (max-width: 601px) {
  .cart-wrapper {
    left: 0px;
    padding: 5px;
    height: 100%;
    width: 100vw;
    overflow-y: auto;
    padding-bottom: 40px;
  }
  header {
    // box-shadow: unset;
    // position: unset;
  }
  .back-btn {
    background: linear-gradient(
      235.26deg,
      $primaryColor 0%,
      $primaryColor 40.5%,
      #cacaca 94%,
      #e0e0e0 100%
    );
    width: 66px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-left: 10px;
    border-radius: 50px 0px 0px 50px;
    .icon-back {
      color: white;
    }
  }

  header .v-container {
    // min-height: 90px;
  }

  .siteLogo {
    height: 50px;
  }
}

@media only screen and (min-width: 768px) and (max-width: 993px) {
  .siteLogo {
    margin-left: 10px;
  }
}

@media (min-width: 1044px) {
  .siteLogo {
    height: 60px;
  }
  .nav-cards {
    display: flex;
    gap: 10px;
  }
}
</style>
